import request from '@/utils/request'
import { TenantParams } from '@/types/tenant/tenantManage'
/**
 * 租户详情
 */
export const fetchTenantDetail = (params: TenantParams) => {
  return request({
    url: '/blackcat/tenant/detail',
    method: 'get',
    params
  })
}
